<template>
  <div>
    <vs-tooltip color="primary" :text="params.data.shared === 0 ? 'Share' : 'Shared'" position="top">
      <vs-button
        :disabled="params.data.shared !== 0"
        class="includeIcon includeIconOnly"
        type="border"
        @click="params.colDef.CellRendererParams.studentReportShare(params.data)"
      >
        <span class="material-icons share-rotate">reply</span>
      </vs-button>
    </vs-tooltip>
  </div>
</template>
<script>
export default {
  name: 'GradebookShareCell'
}
</script>